export const ROUTERS = {
  HOME: "/",
  LOGIN: "/login",
  APP: "/app",
  ERROR_GLITCH: "/error-glitch",
  DASHBOARD_DAILY_ANALYSIS: "/dashboard/daily-analysis",
  DASHBOARD_USER_ANALYSIS: "/dashboard/user-analysis",
  DASHBOARD_STATISTIC: "/dashboard/statistic",
  DASHBOARD_PAYROLL: "/dashboard/payroll",
  TIME_CHECK: "/time",
  TIME_KEY: "/time/:key",
  CALENDAR: "/calendar",
  PROFILE_WORKED_SHIFT: "/profile/worked-shift",
  PROFILE_LEAVE_TYPE: "/profile/leave-type",
  DAILY_REPORT_MY_REPORT: "/daily-report/my-report",
  DAILY_REPORT_ALL_REPORTS: "/daily-report/all-reports",
  DASHBOARD: "/dashboard",
  ORGANIZATION_USER_PROFILE: "/organization/user-profile",
  BRANCH: "/branch",
};
